import { FlatPanelConfigurationState } from 'app/redux/flatPanelConfiguration/reducer';
import { getDetectorManager, initDetectorManager } from 'app/utils/xray/DetectorManager';

export default class NativeFlatPanelDetectorManagerInitializer {
  init = (config: FlatPanelConfigurationState) => initDetectorManager(config);

  get = () => getDetectorManager();
}
